import {ExtensionConfig, SimpleXdmExtension} from '../SimpleXdmExtension';
import {MockConnectIframeInterface} from "./MockConnectIframeInterface";

export class MockSimpleXdmExtension implements SimpleXdmExtension {
  iframeAttributes = new MockConnectIframeInterface();
  extension = {};
}
